import React, { useState, useEffect } from 'react';

import { Drawer, Table, Pagination } from 'antd';
import { configcolumn } from './config';
import { pageTaskRecord } from './api';
// import { EditOutlined } from '@ant-design/icons';
import IconFont from '../../compoment/iconFont';
import './downCenter.less';
const DownCenter = (props) => {
	// 初始化查詢
	useEffect(() => {}, []);

	const [tableData, setTableData] = useState([]);
	const [total, setTotal] = useState(11);
	const [open, setOpen] = useState(false);
	const drawerTitle = '下载中心';
	const [loading, setLoading] = useState(false);
	// 触发反馈管理抽屉
	const showDrawer = () => {
		console.log('触发弹框');
		setOpen(true);
		//setTableData([{}]);
		getList();
	};
	const onClose = () => {
		setOpen(false);
	}; // 控制隐藏悬浮提示文字
	const feedBackEnter = () => {
		setIsHovered(true);
	};
	const feedBackLeave = () => {
		setIsHovered(false);
	};
	const [feedbackVisible, setIsHovered] = useState(false);
	function getList(newPageNum, newPageSize) {
		setLoading(true);
		pageTaskRecord({
			condition: {
				bizTypeCode: '',
				bizTypeName: '',
				operatorId: '',
				operatorName: '',
				statusCode: '',
				taskCode: '',
				taskName: ''
			},
			pageNum: newPageNum || 1,
			pageSize: newPageSize || 10
		}).then((res) => {
			if (res.success) {
				setTableData(res.data.records);

				setTotal(res.data.total);
				console.log('表格数据', tableData);
			}
			setLoading(false);
			//tableData = res.data.records;
		});
	}

	// 表格分页改变
	function paginationChange(pageNum, pageSize) {
		getList(pageNum, pageSize);
	}
	return (
		<>
			<div className="feedbackText" onClick={showDrawer} onMouseEnter={feedBackEnter} onMouseLeave={feedBackLeave}>
				<IconFont xiazaizhongxin className="downCenterIcon" type="icon-xiazaizhongxin" />

        
				{feedbackVisible && <span className="feedbackText_yj">下载中心</span>}
			</div>
			<Drawer placement="right" onClose={onClose} title={drawerTitle} visible={open} width="900" maskClosable={false}>
				<Table
					rowKey={(record) => {
						return record.id; //在这里加上一个时间戳就可以了
					}}
					loading={loading}
					columns={configcolumn}
					dataSource={tableData}
					pagination={false}
				/>{' '}
				<div className="tablePagination">
					<Pagination defaultCurrent={1} total={total} onChange={paginationChange} showSizeChanger></Pagination>
				</div>
			</Drawer>
		</>
	);
};
export default DownCenter;
